import React from 'react'
import { Link } from 'react-router-dom'
import route from '../../stores/fetchconfig.json'

export default class AccessNotAllowed extends React.Component {
  render () {
    return (
      <div> not allowed
       <Link to={route.endpoint + "/admin"}>Log Dich erneut ein</Link>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/AccessNotAllowed.js